import React, { Component } from 'react';

import User from "../assets/img/user.svg";
import {Link} from "react-router-dom";
import ArrowBackIcon from '../assets/img/backarrow.svg';
export default class TituloEditarperfil extends Component {
  handleClickSalir = async () => {
    localStorage.removeItem("userLogin");
    localStorage.removeItem("studientActive");
    localStorage.removeItem("studientList");
    window.location.href = "/Login";
  };

  render() {
    const _isMobile = this.props.isMobile;
    const redirec = this.props._redirec;
    const filter = this.props._filter;
    
    const dataUser = JSON.parse(localStorage.getItem("userLogin"));
    const event = new Date();
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return (
      <div className="editar-perfil-head">
        <div className=" row">
          <div className=" col-12">
            <div className=" row">
              <div className={!_isMobile ? "col-7" : "col-10"}>
                {filter == "D" ? (
                  <>
                    <div className="row">
                      <div style={{ textAlign: "left", paddingLeft: "15px" }}>
                        <Link to={redirec}>
                          <div id="returnicon">
                            <img src={ArrowBackIcon} />
                          </div>
                        </Link>
                      </div>
                      <div style={{ textAlign: "left", paddingLeft: "15px" }}>
                        <h1 className="titulo-menu">
                          {this.props.nombreTitulo}
                        </h1>
                        <h1 className="fecha-menu">
                          {event.toLocaleDateString("es-ES", options)}
                        </h1>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <h1 className="titulo-menu">{this.props.nombreTitulo}</h1>
                    <h1 className="fecha-menu">
                      {event.toLocaleDateString("es-ES", options)}
                    </h1>
                  </>
                )}
              </div>
              <div className={!_isMobile ? "col-5" : "col-2"}>
                {!_isMobile ? (
                  <>
                    <div style={{ float: "right", textAlign:"right", padding: "0.5% 0 0 0" }}>
                      <table>
                        <tr>
                          <td colSpan="2">
                            <div className="nombre-usuario col-12 perfil-name mb-2">
                              {dataUser.detail.nombres}
                            </div>
                          </td>
                          <td rowSpan="2">
                            <Link to="/editar-perfil">
                              <img src={User} className="user-imagen" />
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="ir-perfil col-12">
                              <Link to="/editar-perfil" className="ir-perfil">
                                Ir a Perfil
                              </Link>
                            </div>
                          </td>
                          <td>
                            <div
                              className="salir-perfil col-12"
                              onClick={this.handleClickSalir}
                            >
                              Salir
                            </div>
                          </td>
                        </tr>
                      </table>
                      {/* <div className="  col-10">
                        <div
                          className="row detalle"
                          style={{ textAlign: "right" }}
                        >
                          <div className="nombre-usuario col-12 perfil-name mb-2">
                            {dataUser.detail.nombres}
                          </div>
                          <div
                            className="row col-12"
                            style={{ textAlign: "right" }}
                          >
                            <div className="col-8">
                              <h1 className="ir-perfil">
                                <Link to="/editar-perfil" className="ir-perfil">
                                  Ir a Perfil
                                </Link>
                              </h1>
                            </div>
                            <div className="col-4">
                              <h1
                                className="salir-perfil"
                                onClick={this.handleClickSalir}
                              >
                                Salir
                              </h1>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2 row float-right">
                        <Link to="/editar-perfil">
                          <img src={User} className="user-imagen" />
                        </Link>
                      </div> */}
                    </div>
                  </>
                ) : (
                  <div className="float-right">
                    <Link to="/editar-perfil">
                      <img src={User} className="user-imagen" />
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}